import React from 'react';
import PropTypes from 'prop-types';
import { Snackbar, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { ToastErrorModel } from '../models';

const ErrorToast = ({ error, close }) => {
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    close(error);
  };
  return (
    <Snackbar
      message={error.message}
      open={error.open}
      autoHideDuration={10000}
      onClose={handleClose}
      action={[
        <IconButton
          key="close"
          aria-label="close"
          color="inherit"
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>,
      ]}
    />
  );
};

ErrorToast.propTypes = {
  close: PropTypes.func,
  error: PropTypes.oneOfType([ToastErrorModel]),
};

export default ErrorToast;
